import Types, { IAppState, GlobalState } from '../../models/action/core.d';
import Moment from 'moment';
import * as ActionConstants from '../constants/notification';
import * as Actions from '../../models/action/notification';
import { Log } from 'ng2-logger';

const _logger = Log.create('Notification-Reducer');

const notificationReducer = (state = GlobalState().notification, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    const newState: any = { ...state };

    if (action.type === ActionConstants.actions.SET_NOTIFICATIONS) {
        const notificationPageAction = action as Actions.ISetNotifications;


        if (notificationPageAction.notifications !== undefined && !notificationPageAction.isOnlyCount) {
            newState.notifications = notificationPageAction.notifications.results;
        }

        if (notificationPageAction.notifications.filters.totalUnreadCount)
        {
            newState.unreadNotificationCount = notificationPageAction.notifications.filters.totalUnreadCount;
        }

    
    } 
    else if (action.type === ActionConstants.actions.SET_NOTIFICATIONS_ALL) {

        const notificationPageAction = action as Actions.ISetNotificationsALL;

        if (notificationPageAction.notificationsAll !== undefined && !notificationPageAction.isOnlyCountAll) {
            newState.notificationsAll = notificationPageAction.notificationsAll.results;
        }

        if(notificationPageAction.notificationsAll.filters ) {
            newState.unreadNotificationCountAll = notificationPageAction.notificationsAll.filters.total;
        }

        if(notificationPageAction.unreadNotificationCountAll && notificationPageAction.unreadNotificationCountAll > 0) {
            newState.notificationsAll = [];
        }
    }
    else if (action.type === ActionConstants.actions.SET_ACTIVITY_NOTIFICATIONS) {
        
        const notificationPageAction = action as Actions.ISetActivityNotifications;


        if (notificationPageAction.activityNotifications !== undefined) {
            newState.activityNotifications = notificationPageAction.activityNotifications.results;
        }


    } 
    else if (action.type === ActionConstants.actions.SET_ACTIVITY_NOTIFICATIONS_ALL) {
        const notificationPageAction = action as Actions.ISetActivityNotificationsALL;


        if (notificationPageAction.activityNotificationsAll !== undefined && !notificationPageAction.activityIsOnlyCountAll) {
            newState.activityNotificationsAll = notificationPageAction.activityNotificationsAll.results;
        }

        if(notificationPageAction.activityNotificationsAll.filters ) {
            newState.activityUnreadNotificationCountAll = notificationPageAction.activityNotificationsAll.filters.total;
        }

        if(notificationPageAction.activityUnreadNotificationCountAll && notificationPageAction.activityUnreadNotificationCountAll > 0) {
            newState.activityNotificationsAll = [];
        }
    }
    else {
        return state;
    }
    return Object.assign({}, state, newState);
};

export default notificationReducer;